import { Config } from '#/global/helper/Config'

export enum ImageSource {
    productEshop = '{baseUrl}/{shopId}/img/product/{src}.webp',
    productGift = '{baseUrl}/{shopId}/img/product-gift/{src}.webp',
    productRental = '{baseUrl}/{shopId}/img/product-rental/{src}.webp',
}

export const IMAGE_NOT_FOUND = `${Config.getBaseCdn()}/img/2711ac4e3e85e0ac6233b02388095dbb.jpg`

const imageFileExtensionRegex = /(\.jpg|\.png|\.jpeg|\.webp)/
const widthRegex = /_[er]w\d+/
const heightRegex = /_[er]h\d+/

export const toWebp = (source: string) => source.replace(imageFileExtensionRegex, '.webp')

export const exactWidth = (source: string, width: number) => {
    if (widthRegex.test(source)) {
        console.warn('Source already has exact or resize width')
        return source
    }
    return source.replace(imageFileExtensionRegex, `_ew${width}$1`)
}

export const exactHeight = (source: string, height: number) => {
    if (heightRegex.test(source)) {
        console.warn('Source already has exact or resize height')
        return source
    }
    return source.replace(imageFileExtensionRegex, `_eh${height}$1`)
}

export const resizeWidth = (source: string, width: number) => {
    if (widthRegex.test(source)) {
        console.warn('Source already has exact or resize width')
        return source
    }
    return source.replace(imageFileExtensionRegex, `_rw${width}$1`)
}

export const resizeHeight = (source: string, height: number) => {
    if (heightRegex.test(source)) {
        console.warn('Source already has exact or resize height')
        return source
    }
    return source.replace(imageFileExtensionRegex, `_rh${height}$1`)
}

export const createImageFromSource = (source: string, baseSource: ImageSource) => {
    return baseSource
        .replace('{baseUrl}', Config.getBaseCdn())
        .replace('{shopId}', Config.getShopId())
        .replace('{src}', source.toString())
}

class Image {
    constructor(private source: string = IMAGE_NOT_FOUND, imageSource?: ImageSource) {
        this.source = source.startsWith(Config.getBaseCdn())
            ? source
            // hledá všechny výskyty https://....cz a nahradí je za base cdn
            : source.replace(/^https:\/\/\S*\.cz/, Config.getBaseCdn())

        if (imageSource !== undefined) {
            this.source = createImageFromSource(this.source, imageSource)
        }
    }

    exactHeight(height: number) {
        this.source = exactHeight(this.source, height)
        return this
    }

    exactWidth(width: number) {
        this.source = exactWidth(this.source, width)
        return this
    }

    getSource() {
        return this.source
    }

    resizeHeight(height: number) {
        this.source = resizeHeight(this.source, height)
        return this
    }

    resizeWidth(width: number) {
        this.source = resizeWidth(this.source, width)
        return this
    }

    toWebp() {
        this.source = toWebp(this.source)
        return this
    }
}

export default Image
